import { MINT } from "@/config/mui/colorPalette";

type Props = {
  size?: string;
};

export default function CheckMark({ size = "160" }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="80" cy="80" r="80" fill={MINT[40]} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M123.759 52.2815C126.153 54.6943 126.137 58.5906 123.724 60.9843L77.2014 107.138C76.0018 108.328 74.4345 108.923 72.8673 108.923C71.3001 108.923 64.3133 108.923 60.621 108.923L48.5946 87.3578C46.1818 84.9642 38.5353 79.248 40.9289 76.8352C43.6981 76.8352 51.3456 76.8353 52.9287 76.8352C54.4954 76.8352 56.0626 77.4298 57.2627 78.6204L72.8673 94.101L107.083 50.4617C112.006 50.4617 117.823 50.4617 119.39 50.4617C120.973 50.4617 122.556 51.0688 123.759 52.2815Z"
        fill="#33CC99"
        stroke={MINT[100]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.066 52.2815C114.46 54.6942 114.444 58.5906 112.031 60.9842L65.5086 107.138C63.1094 109.518 59.2397 109.518 56.8405 107.138L36.9018 87.3578C34.489 84.9642 34.4735 81.0678 36.8671 78.655C39.2608 76.2422 43.1571 76.2267 45.5699 78.6203L61.1745 94.101L103.363 52.2468C105.776 49.8532 109.673 49.8687 112.066 52.2815Z"
        fill="white"
        stroke={MINT[100]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
